<template>

    <KedvezmenyekBase>

        <v-layout row wrap slot="kedvezmeny" ref="kedvezmeny" style="max-width: 100%;">

            <BnFormField v-if="biztkozvetitoiVisible()" :attributes="biztkozvetitoi" />

            <BnFormField :attributes="kiemeltpartner" />

            <BnFormField v-if="gyermekgondozasVisible()" :attributes="gyermekgondozas" />

        </v-layout>

    </KedvezmenyekBase>

</template>

<script>
import BnFormField from '../../../../../../basecomponents/BnFormField.vue';
import Kedvezmeny from '../../../../mixins/dijak/kedvezmenyek/Kedvezmeny';
import KedvezmenyekBase from '../KedvezmenyBase.vue';
import TariffAnnouncementUtils from '../../../../../../../utils/TariffAnnouncementUtils';

export default {
    name: 'KedvezmenyekB16',
    components: { BnFormField, KedvezmenyekBase },
    mixins: [Kedvezmeny],
    methods: {
        biztkozvetitoiVisible() {
            return (this.isSZGK() || this.isTeherKisebb3500kg()) && this.isTermeszetesSzemely();
        },
        gyermekgondozasVisible() {
            return this.isSZGK() && this.isTermeszetesSzemely() && this.hasDrivingLicence()
                && TariffAnnouncementUtils.isKockakezdetEqualOrGreater(2026, 'kgfb', this.$store);
        },
    },
    data() {
        return {
            biztkozvetitoi: {
                type: 'checkbox',
                label: 'Biztosítás közvetítői kedvezmény',
                visible: true,
                editable: !this.disabled,
                rules: [],
                mezo: 'waberer_biztkozvetitoi',
                path: 'kedvezmenyekbiztosito.16.biztkozvetitoi',
                help: true,
                change: this.shouldRecalc,
            },
            kiemeltpartner: {
                type: 'checkbox',
                label: 'Kiemelt partner kedvezmény',
                visible: true,
                editable: !this.disabled,
                rules: [],
                mezo: 'waberer_kiemeltpartner',
                path: 'kedvezmenyekbiztosito.16.kiemeltpartner',
                help: true,
                change: this.shouldRecalc,
            },
            gyermekgondozas: {
                type: 'checkbox',
                label: 'Gyermeknevelési kedvezmény',
                visible: true,
                editable: !this.disabled,
                rules: [],
                mezo: 'waberer_gyermekgondozas',
                path: 'kedvezmenyekbiztosito.16.gyermekgondozas',
                help: true,
                change: this.shouldRecalc,
            },
        };
    },
};
</script>
